


export const HOSTNAME = 'https://r-722024-1---service-api-d6vxitfn5a-uc.a.run.app';
// export const HOSTNAME = 'http://localhost:8081';



export const LargeDataAnalyticsHostname = 'https://r-7-4-2024-v2---large-data-analytics-d6vxitfn5a-uc.a.run.app';

export const GoogleCloudStorageBucketUrl = 'https://storage.googleapis.com/users-webapp-platform-storage/';


export const UPLOAD_URL = `${HOSTNAME}/files/editor/upload`;
export const FETCH_RESOURCE_URL = `${HOSTNAME}/files/serve`;


